export default __webpack_public_path__ + "static/media/placeholder-league-featured.240e21f9.svg";